import { render, staticRenderFns } from "./ListaConfigNiveis.vue?vue&type=template&id=7f11b904&scoped=true&"
import script from "./ListaConfigNiveis.vue?vue&type=script&lang=js&"
export * from "./ListaConfigNiveis.vue?vue&type=script&lang=js&"
import style0 from "./ListaConfigNiveis.vue?vue&type=style&index=0&id=7f11b904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f11b904",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})
